module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAIFJREFUWEdjZBhgwDjA9jOMOmBoh0BUevl8xv//Xy+d1VVGblqiKASi0sr/gyxeNquTbHPI1giyeNQBoyEwGgLDNwSi08q6/jMwlpJbumHVx8iwYNnMzkR0OawF0YA7gFifD980MBoCoyEwGgJDJwQGulFKbEjhU0dRo3TUAcMiBADbGmIhyu+qXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.png
// module id = Zarb
// module chunks = 1